module.exports = __webpack_public_path__ + "img/kma_gallery10.e7c71d61.jpg";